import { type HTMLAttributes } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cnTwMerge("skeleton-box", className)} {...props} />;
}

export { Skeleton };
